import { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import {
    businessTypesUrl,
    businessTypesByMemberTypeUrl,
    fetchBusinessTypes,
    fetchBusinessTypesByMemberType,
} from '@general/api/businessTypesAPI';

const useBusinessTypesForMemberType = memberType => {
    const [businessTypes, setBusinessTypes] = useState();

    const { data: allBusinessTypes } = useQuery(businessTypesUrl, fetchBusinessTypes(), {
        cacheTime: Infinity,
        staleTime: Infinity,
        refetchOnWindowFocus: false,
        refetchOnMount: false,
        refetchOnReconnect: false,
    });

    const { data: businessTypesByMemberType } = useQuery(
        businessTypesByMemberTypeUrl,
        fetchBusinessTypesByMemberType(),
        {
            cacheTime: Infinity,
            staleTime: Infinity,
            refetchOnWindowFocus: false,
            refetchOnMount: false,
            refetchOnReconnect: false,
        }
    );

    useEffect(() => {
        if (!allBusinessTypes || !businessTypesByMemberType) {
            return;
        }

        const businessTypesForMemberType = businessTypesByMemberType[memberType];
        if (businessTypesForMemberType) {
            setBusinessTypes(allBusinessTypes.filter(type => businessTypesForMemberType.includes(type.code)));
        } else {
            setBusinessTypes([]);
        }
    }, [memberType, allBusinessTypes, businessTypesByMemberType]);

    return { data: businessTypes };
};

export default useBusinessTypesForMemberType;
